<template>
    <footer class="bg-black text-white py-8">
        <div class="container mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
            <!-- Logo and Description -->
            <div class="text-center md:text-left">
                <img src="@/assets/bsclogo.png" alt="Bhawal Sena Club Logo" class="h-16 mx-auto md:mx-0" />
                <p class="mt-4 text-gray-300">
                    Bhawal Sena Club is a community-driven organization dedicated to social welfare,
                    events, and community engagement.
                </p>
            </div>

            <!-- Useful Links -->
            <div>
                <h3 class="text-lg font-bold text-center md:text-left mb-4">Useful Links</h3>
                <ul class="space-y-2 text-center md:text-left">
                    <li>
                        <router-link to="/" class="hover:text-gray-400">Home</router-link>
                    </li>
                    <li>
                        <router-link to="/about" class="hover:text-gray-400">About Us</router-link>
                    </li>
                    <li>
                        <router-link to="/members" class="hover:text-gray-400">Members</router-link>
                    </li>
                    <li>
                        <router-link to="/blood-donation" class="hover:text-gray-400">Blood Donation</router-link>
                    </li>
                    <li>
                        <router-link to="/gallery" class="hover:text-gray-400">Gallery</router-link>
                    </li>
                    <li>
                        <router-link to="/contact" class="hover:text-gray-400">Contact</router-link>
                    </li>
                </ul>
            </div>

            <!-- Social Icons -->
            <div>
                <h3 class="text-lg font-bold text-center md:text-left mb-4">Contact & Social</h3>
                <p class="text-center md:text-left mb-4">
                    📞 <a href="tel:+8801308439359" class="hover:text-gray-400">+880 1308 439359</a>
                    <br />
                    ✉️ <a href="mailto:bhawalsenaclub@gmail.com"
                        class="hover:text-gray-400">bhawalsenaclub@gmail.com</a>
                </p>
                <div class="flex justify-center md:justify-start space-x-4">
                    <a href="https://youtube.com/@bhawalsenaclub" target="_blank" class="hover:text-gray-400">
                        <i class="fab fa-youtube text-xl"></i>
                    </a>
                    <a href="https://facebook.com/profile.php?id=61567809000093" target="_blank"
                        class="hover:text-gray-400">
                        <i class="fab fa-facebook text-xl"></i>
                    </a>
                    <a href="https://instagram.com/bhawal_sena_club" target="_blank" class="hover:text-gray-400">
                        <i class="fab fa-instagram text-xl"></i>
                    </a>
                    <a href="https://threads.net/@bhawal_sena_club" target="_blank" class="hover:text-gray-400">
                        <i class="fab fa-threads text-xl"></i>
                    </a>
                    <a href="https://twitter.com/bhawalsena_club" target="_blank" class="hover:text-gray-400">
                        <i class="fab fa-twitter text-xl"></i>
                    </a>
                </div>
            </div>
        </div>
        <div class="mt-8 text-center border-t border-gray-700 pt-4">
            © 2025 Bhawal Sena Club. All rights reserved.
        </div>
    </footer>
</template>

<script>
export default {};
</script>

<style scoped>
@import "@fortawesome/fontawesome-free/css/all.css";
</style>
